/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import $script from 'scriptjs'
import App from './App'
import { SettingsManager } from './configuration/SettingsManager'
import './index.scss'
import * as serviceWorker from './serviceWorker'
import { createBrowserHistory } from 'history'
import ReactGA from 'react-ga4'

// create the browser history
export const history = createBrowserHistory({
	basename: process.env.PUBLIC_URL,
})

ReactGA.initialize("G-WBTY070CE1")

export const getUrlVars = (): { [key: string]: string } => {
	const result: { [key: string]: string } = {}
	window.location.href
		.slice(window.location.href.indexOf('?') + 1)
		.split('&')
		.forEach(element => {
			const hash: string[] = element.split('=')
			result[hash[0]] = hash[1]
		})
	return result
}

// ensure appConfig.js is loaded without caching
$script(`${process.env.PUBLIC_URL}/appConfig.js?_=${Date.now()}`, () => {
	// configure the container... this must be done BEFORE rendering the App but AFTER importing service locator
	SettingsManager.configureContainer()
	ReactDOM.render(<App />, document.getElementById('root'))
	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorker.unregister()
})
